import React from "react";
import {
  Box,
  Breadcrumbs,
  Link,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import Icon from "../../Icon/Icon";

// Header including icon, title, subtitle, subtitle and breadcrumb by MaterialUI
export const EGPageHeader = ({
  title = "",
  subtitle = "",
  mainIconName,
  breadcrumbItems = [],
  border = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      bgcolor={theme.palette.background.paper}
      border={border ? `1px solid ${theme.palette.blueGray100.main}` : ""}
      px={1.5}
      py={0}
      pb={{ xs: 1, sm: 0 }}
      className="rounded"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", sm: "space-between" },
        flexFlow: "wrap",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexShrink: 1,
          minWidth: 0,
        }}
      >
        <ListItem alignItems="center" dense sx={{ px: 0, py: 0.33 }}>
          {mainIconName && (
            <ListItemAvatar
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 0,
                mr: 1,
              }}
            >
              <Icon
                name={mainIconName}
                color={theme.palette.secondary.main}
                size={30}
              />
            </ListItemAvatar>
          )}
          <ListItemText
            primary={title}
            primaryTypographyProps={{ variant: "h5" }}
            secondary={subtitle}
            secondaryTypographyProps={{ variant: "body2", fontSize: 12 }}
          />
        </ListItem>
      </Box>
      {breadcrumbItems.length > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexShrink: 1,
            minWidth: 0,
            overflow: "hidden",
            pl: 1,
          }}
        >
          <Breadcrumbs
            aria-label="breadcrumb"
            separator=">"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flexShrink: 0,
            }}
          >
            {breadcrumbItems.map((breadcrum, i) => {
              const isCurrentPath = i === breadcrumbItems.length - 1;

              if (isCurrentPath) {
                return (
                  <Typography
                    key={i}
                    variant="body2"
                    fontSize={11}
                    color="text.primary"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {breadcrum?.iconName && (
                      <Icon
                        name={breadcrum.iconName}
                        color={theme.palette.secondary.main}
                        size={13}
                      />
                    )}
                    <Box component="span" ml={breadcrum.label ? 0.5 : 0}>
                      {breadcrum.label}
                    </Box>
                  </Typography>
                );
              }

              return (
                <Link
                  key={i}
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href={breadcrum?.route}
                >
                  {breadcrum?.iconName && (
                    <Icon
                      name={breadcrum.iconName}
                      color={theme.palette.secondary.main}
                      size={13}
                    />
                  )}
                  <Box
                    component="span"
                    fontSize={11}
                    ml={breadcrum.label ? 0.5 : 0}
                  >
                    {breadcrum.label}
                  </Box>
                </Link>
              );
            })}
          </Breadcrumbs>
        </Box>
      )}
    </Box>
  );
};
